import { render } from "./AppBody.vue?vue&type=template&id=b19fa010"
import script from "./AppBody.vue?vue&type=script&lang=js"
export * from "./AppBody.vue?vue&type=script&lang=js"

import "./AppBody.vue?vue&type=style&index=0&id=b19fa010&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__